import { Selectors as UserSelectors } from "@/store/user/selectors";
import { SaloonStaffCacheService } from "./cache";
import { Actions as UserActions } from "@/store/user/slice";
import { SchedulerCacheService } from "../scheduler/cache";
import { TasksCacheService } from "../tasks/cache";
import { FreeSlotsCacheService } from "../freeSlots/cache";
import { SaloonsCacheService } from "../saloons/cache";
import { getReduxStore } from "@/store";
import { TaskEditorCacheService } from "../taskEditor/cache";
import { Effects as AuthEffects } from "@/store/auth/effects";

export const SaloonStaffMutationHandler = {
  masterAdded({ saloon_id, master_id }) {
    SaloonStaffCacheService.invalidateMasters(saloon_id);
    const reduxStore = getReduxStore();
    const authMasterId = UserSelectors.getMasterId(reduxStore.getState());
    if (authMasterId === master_id) {
      // we do this one to update "saloon" field on the master cause we populate it on the server, e.g. it is not a simple string that can be just replaced
      reduxStore.dispatch(AuthEffects.sessionLogin());

      TaskEditorCacheService.invalidateByMaster(master_id);
      SaloonsCacheService.invalidateMySaloons();
    }
  },
  adminAdded({ saloon_id, user_id }) {
    SaloonStaffCacheService.invalidateAdmins(saloon_id);
    const reduxStore = getReduxStore();
    const authUserId = UserSelectors.getUserId(reduxStore.getState());
    if (authUserId === user_id) {
      SaloonsCacheService.invalidateMySaloons();
    }
  },
  memberUpdated({
    saloon_id,
    is_master,
    is_admin,
    is_owner,
    user_id,
    master_id,
    employee_updates,
    master_updates,
    user_updates,
  }) {
    if (is_admin) {
      SaloonStaffCacheService.updateAdmin({
        userId: user_id,
        saloonId: saloon_id,
        userUpdates: user_updates,
        employeeUpdates: employee_updates,
      });
    }
    if (is_master) {
      SaloonStaffCacheService.updateMaster({
        userId: user_id,
        masterId: master_id,
        saloonId: saloon_id,
        masterUpdates: master_updates,
        userUpdates: user_updates,
        employeeUpdates: employee_updates,
      });
    }
    // TODO:: update the saloons cache
    if (is_owner) {
    }
  },
  premiumUpdated({ saloon_id, is_admin, is_master, master_id, premium }) {
    if (is_admin) {
      SaloonStaffCacheService.updateAdmin({
        saloonId: saloon_id,
        userId: premium.owner,
        premiumAccountUpdates: premium,
      });
    }
    if (is_master) {
      SaloonStaffCacheService.updateMaster({
        saloonId: saloon_id,
        masterId: master_id,
        userId: premium.owner,
        premiumAccountUpdates: premium,
      });
    }
  },
  adminRemoved({ admin_id, saloon_id }) {
    // TODO:: remove the admin from the saloons cache
    SaloonStaffCacheService.removeAdmin({ id: admin_id, saloonId: saloon_id });

    const reduxStore = window.__reduxStore;
    const reduxState = reduxStore.getState();
    const authUserId = UserSelectors.getUserId(reduxState);
    if (authUserId === admin_id) {
      SaloonsCacheService.invalidateMySaloons();
    }
  },
  masterRemoved({ master_id, saloon_id, kept_in_masters_list }) {
    // TODO:: remove the master from the saloons cache
    if (kept_in_masters_list) {
      // TODO:: update the cache instead of invalidating
      SaloonStaffCacheService.invalidateMasters(saloon_id);
    } else {
      SaloonStaffCacheService.removeMaster({
        id: master_id,
        saloonId: saloon_id,
      });
    }
    const reduxStore = window.__reduxStore;
    const reduxState = reduxStore.getState();
    const authMasterId = UserSelectors.getMasterId(reduxState);
    if (authMasterId === master_id) {
      SaloonsCacheService.invalidateMySaloons();
      TaskEditorCacheService.invalidateByMaster(master_id);
      SchedulerCacheService.invalidateAll();
      TasksCacheService.invalidateAll();
      FreeSlotsCacheService.invalidateAll();
      reduxStore.dispatch(
        UserActions.updateMaster({
          saloon: null,
          saloon_meta: null,
        }),
      );
    }
  },
};
